module.exports = __webpack_public_path__ + "img/image_025.b2ec561e.jpeg";